import { createReducer } from '@reduxjs/toolkit'
import { checkoutActions } from './actions'
import { initialState } from './initialState'

/**
 * Reducer do módulo Checkout
 */
export const checkoutReducer = createReducer(initialState, (builder) => {
  builder
    // Step management
    .addCase(checkoutActions.setCurrentStep, (state, action) => {
      state.currentStep = action.payload
    })
    .addCase(checkoutActions.nextStep, (state) => {
      if (state.currentStep < 4) {
        state.currentStep += 1
      }
    })
    .addCase(checkoutActions.prevStep, (state) => {
      if (state.currentStep > 1) {
        state.currentStep -= 1
      }
    })
    
    // Address management
    .addCase(checkoutActions.setShippingAddress, (state, action) => {
      state.shippingAddress = action.payload
    })
    .addCase(checkoutActions.setBillingAddress, (state, action) => {
      state.billingAddress = action.payload
    })
    .addCase(checkoutActions.setSelectedAddressId, (state, action) => {
      state.selectedAddressId = action.payload
    })
    .addCase(checkoutActions.setShowNewAddressForm, (state, action) => {
      state.showNewAddressForm = action.payload
    })
    .addCase(checkoutActions.setAddressConfirmed, (state, action) => {
      state.addressConfirmed = action.payload
    })
    
    // Customer info
    .addCase(checkoutActions.setCustomerInfo, (state, action) => {
      state.customerInfo = { ...state.customerInfo, ...action.payload }
    })
    
    // Shipping
    .addCase(checkoutActions.calculateShippingRequest, (state) => {
      state.isLoadingShipping = true
      state.shippingError = null
    })
    .addCase(checkoutActions.calculateShippingSuccess, (state, action) => {
      state.isLoadingShipping = false
      state.shippingOptions = action.payload.options
    })
    .addCase(checkoutActions.calculateShippingFailure, (state, action) => {
      state.isLoadingShipping = false
      state.shippingError = action.payload.error
    })
    .addCase(checkoutActions.setSelectedShippingOption, (state, action) => {
      state.selectedShippingOption = action.payload
    })
    
    // Coupons
    .addCase(checkoutActions.applyCouponRequest, (state) => {
      state.isLoadingCoupon = true
      state.couponError = null
    })
    .addCase(checkoutActions.applyCouponSuccess, (state, action) => {
      state.isLoadingCoupon = false
      // Verificar se o cupom já está aplicado
      const existingIndex = state.appliedCoupons.findIndex(c => c.code === action.payload.coupon.code)
      if (existingIndex >= 0) {
        state.appliedCoupons[existingIndex] = action.payload.coupon
      } else {
        state.appliedCoupons.push(action.payload.coupon)
      }
      state.couponCode = ''
    })
    .addCase(checkoutActions.applyCouponFailure, (state, action) => {
      state.isLoadingCoupon = false
      state.couponError = action.payload.error
    })
    .addCase(checkoutActions.removeCoupon, (state, action) => {
      state.appliedCoupons = state.appliedCoupons.filter(c => c.code !== action.payload)
    })
    .addCase(checkoutActions.clearCoupons, (state) => {
      state.appliedCoupons = []
    })
    .addCase(checkoutActions.setCouponCode, (state, action) => {
      state.couponCode = action.payload
    })
    
    // Payment
    .addCase(checkoutActions.setPaymentMethod, (state, action) => {
      state.selectedPaymentMethod = action.payload
    })
    .addCase(checkoutActions.createPaymentIntentRequest, (state) => {
      state.isLoadingPayment = true
      state.paymentError = null
    })
    .addCase(checkoutActions.createPaymentIntentSuccess, (state, action) => {
      state.isLoadingPayment = false
      state.clientSecret = action.payload.clientSecret
    })
    .addCase(checkoutActions.createPaymentIntentFailure, (state, action) => {
      state.isLoadingPayment = false
      state.paymentError = action.payload.error
    })
    .addCase(checkoutActions.setShowPaymentForm, (state, action) => {
      state.showPaymentForm = action.payload
    })
    .addCase(checkoutActions.setPaymentProcessed, (state, action) => {
      state.paymentProcessed = action.payload
    })
    
    // Order
    .addCase(checkoutActions.createOrderRequest, (state) => {
      state.isCreatingOrder = true
      state.orderError = null
    })
    .addCase(checkoutActions.createOrderSuccess, (state, action) => {
      state.isCreatingOrder = false
      state.orderId = action.payload.orderId
    })
    .addCase(checkoutActions.createOrderFailure, (state, action) => {
      state.isCreatingOrder = false
      state.orderError = action.payload.error
    })
    
    // Form errors
    .addCase(checkoutActions.setFormErrors, (state, action) => {
      state.formErrors = action.payload
    })
    .addCase(checkoutActions.clearFormErrors, (state) => {
      state.formErrors = {}
    })
    
    // Reset checkout
    .addCase(checkoutActions.resetCheckout, () => {
      return initialState
    })
    
    // Load from storage
    .addCase(checkoutActions.loadCheckoutData, (state, action) => {
      return { ...state, ...action.payload }
    })
})

